export const booztLogo = 'boozt_logo';
export const booztletLogo = 'booztlet_tagline_logo_black_2025';
export const booztletLogoDe = 'booztlet_logo_black_de_2025';
export const booztletMobileLogo = 'booztlet_logo_bold_black';
export const booztletMobileLogoDe = 'booztlet_logo_black_de';

export const themeColor = { light: 'light', dark: 'dark', gray: 'gray' };
